export const DefaultFilterValues: any = {
  countryCode: "",
  language: "EN",
  languageKey: "",
  geographyKey: "",
  clientPaySubmissionKey: "",
  clientData: "MARKET",
  includeClientPaySubmissionKey: "NaN",
  allClientPaySubmissionKey: "",
  marketDefinitionKey: "",
  gradeSetId: "1",
  peerGroupId: "ALL",
  grade: "ALL",
  benchmarkingApproach: "LEVEL_AND_FUNCTION",
  marketYear: "",
  marketClassKey: "ALL",
  marketCompElementKey: 1,
  marketIndustryKey: "ALL",
  marketRegionKey: "ALL",
  marketSubRegionKey: "ALL",
  marketJobFamilyKey: "ALL",
  marketJobSubFamilyKey: "ALL",
  marketEmployeeCountKey: "ALL",
  marketOwnershipTypeKey: "ALL",
  marketPosition: "0.5",
  marketRevenueRangeKey: "ALL",
  marketJobSkillKey: "ALL",
  marketEducationKey: "ALL",
  marketJobEducationKey: "ALL",
  marketJointCommitteeKey: "ALL",
  orgClassKey: "ALL",
  orgCompElementKey: 1,
  orgRegionKey: "ALL",
  orgSubRegionKey: "ALL",
  orgJobFamilyKey: "ALL",
  orgJobSubFamilyKey: "ALL",
  orgJobSkillKey: "ALL",
  orgEducationKey: "ALL",
  orgJobEducationKey: "ALL",
  orgJointCommitteeKey: "ALL",
  orgClientTypeKey: "MARKET",
  pointsMin: "54",
  pointsMax: "17540",
  PERCENTILE: "0.5",
  COMPENSATION: "1",
  PercentileOrder: "Ascending",
  RaisePay: 0,
  RaiseMarket: 0,
  ReportType: "Market",
  MinimumBroadening: 4,
  ReportOnColumns: 1,
  targetRangeMax: 100,
  targetRangeMin: 1,
  SelFilCategoryName: ""
};

export const FilterKeyValue: any = {
  benchmarkingApproach: "pa.benchmarkingApproach",
  companyName: "pa.companyName",
  marketYear: "pa.marketYear",
  marketIndustry: "pa.industryTitle",
  marketOwnership: "pa.ownershipTypeTitle",
  marketRevenue: "pa.revenueRangeTitle",
  marketEmployeeCount: "pa.numberOfEmployees",
  marketRegion: "pa.regionTitle",
  marketClass: "pa.class",
  marketSubRegion: "pa.marketSubRegion",
  marketJobFamilyKey: "pa.jobFunctionTitle",
  marketJobSubFamilyKey: "pa.jobSubFunctionTitle",
  marketEducationKey: "pa.marketEducation",
  marketJobSkillKey: "pa.marketJobSkill",
  marketJointCommitteeKey: "pa.marketJointCommittee",
  marketJobEducationKey: "pa.marketJobEducation",
  orgClassKey: "pa.class",
  orgRegion: "pa.regionTitle",
  orgSubRegion: "pa.subRegionTitle",
  orgJobFamilyKey: "pa.jobFunctionTitle",
  orgJobSubFamilyKey: "pa.jobSubFunctionTitle",
  clientDataType: "pa.clientDataTypeTitle",
  orgEducationKey: "pa.educationTitle",
  orgJobSkillKey: "pa.jobSkills",
  orgJointCommitteeKey: "pa.jointCommittee",
  orgJobEducationKey: "pa.jobEducationTitle",
  marketCompElementKey: "pa.compensationElement",
  reportOnColumns: "pa.reportOnColumns",
  CompanyName: "pa.companyName",
  grade: "pa.grade",
  peerGroup: "pa.peergrouptitle"
};

export const FilterNames: any = {
  yourOrganizationData: "ORGANIZATIONDATA",
  dataSelection: "DATASELECTION",
  marketYear: "MARKETYEAR",
  rewardBenchmarkApproach: "REWARDSBENCHMARKAPPROACH",
  jobClass: "CLASS",
  jobFamily: "JOBFAMILY",
  jobSubFamily: "JOBSUBFAMILY",
  jobSkill: "JOBSKILL",
  education: "EDUCATION",
  jobEducation: "JOBEDUCATION",
  businessUnit: "BusinessUnit",
  jointCommittee: "JOINTCOMMITTEE",
  region: "REGION",
  subRegion: "SUBREGION",
  industry: "INDUSTRY",
  ownershipType: "OWNERSHIPTYPE",
  revenueRange: "REVENUERANGE",
  employeeCount: "EMPLOYEECOUNT",
  compensation: "COMPENSATION",
  clientDataType: "ClientDataType",
  ReportLayout: "ReportLayout",
  targetRange: "TargetRange",
  minimumNumberOfOrganizationsBeforeBroadening:
    "MinimumNumberOfOrganizationsBeforeBroadening"
};

export const FilterCategoryName: any = {
  market: "marketFilters",
  organization: "organizationFilters",
  customize: "configFilters",
  downloadYourReport: "downloadYourReport"
};


export const ParticipatePackageAllMarketPayloadKeys: string[] = [
  "marketIndustryKey",
  "marketRegionKey",
  "marketEmployeeCountKey",
  "marketOwnershipTypeKey",
  "marketRevenueRangeKey",
  "marketClassKey"
];

/** Market filters locked (all-selected + disabled) for participate/basic packages */
export const ParticipatePackageLockedFilters: string[] = [
  FilterNames.industry,
  FilterNames.employeeCount,
  FilterNames.revenueRange,
  FilterNames.ownershipType,
  // FilterNames.jobSubFamily,
  FilterNames.jobSkill,
  FilterNames.region,
  FilterNames.education,
  FilterNames.jobEducation

];
